import { useState } from 'react'
import { CustomPriceInput } from '../../components/CustomPriceInput'
import { adaptValue } from '../../utils/adaptValue'
import { CustomButton } from '../../components/CustomButton'

export const ListaAnuncios = ({ data, setData }) => {
  const { anuncios = [], composicoes = [] } = data
  const [openMap, setOpenMap] = useState({})

  const toggleCollapse = (id) => {
    setOpenMap((prev) => ({ ...prev, [id]: !prev[id] }))
  }

  /* --- MÉTODOS DE SELEÇÃO GERAL --- */
  function selecionarTodos(checked) {
    setData((pv) => ({
      ...pv,
      anuncios: (pv.anuncios || []).map((anuncio) => ({
        ...anuncio,
        selected: checked,
        variacoes: (anuncio.variacoes || []).map((v) => ({
          ...v,
          selected: checked,
        })),
      })),
      composicoes: (pv.composicoes || []).map((comp) => ({
        ...comp,
        selected: checked,
        variacoes: (comp.variacoes || []).map((v) => ({
          ...v,
          selected: checked,
        })),
      })),
    }))
  }

  function selecionarTodosPorGrupo(grupo, checked) {
    setData((pv) => ({
      ...pv,
      [grupo]: (pv[grupo] || []).map((item) => ({
        ...item,
        selected: checked,
        variacoes: (item.variacoes || []).map((v) => ({
          ...v,
          selected: checked,
        })),
      })),
    }))
  }

  function selecionarPai(grupo, indexItem, checked) {
    setData((pv) => {
      const lista = [...pv[grupo]]
      const item = lista[indexItem]
      lista[indexItem] = {
        ...item,
        selected: checked,
        variacoes: (item.variacoes || []).map((v) => ({
          ...v,
          selected: checked,
        })),
      }
      return { ...pv, [grupo]: lista }
    })
  }

  function selecionarVariacao(grupo, indexPai, indexVar, checked) {
    setData((pv) => {
      const lista = [...pv[grupo]]
      const pai = lista[indexPai]
      const variacoes = [...pai.variacoes]

      variacoes[indexVar] = { ...variacoes[indexVar], selected: checked }
      const todasSelecionadas = variacoes.every((v) => v.selected)

      lista[indexPai] = {
        ...pai,
        selected: todasSelecionadas,
        variacoes,
      }
      return { ...pv, [grupo]: lista }
    })
  }

  /* --- MÉTODOS DE ALTERAÇÃO DE PREÇO --- */
  function alterarPrecoPai(grupo, indexPai, novoPreco) {
    setData((pv) => {
      const lista = [...pv[grupo]]
      const pai = lista[indexPai]
      lista[indexPai] = {
        ...pai,
        price: novoPreco,
        variacoes: (pai.variacoes || []).map((v) => ({
          ...v,
          price: novoPreco,
        })),
      }
      return { ...pv, [grupo]: lista }
    })
  }

  function alterarPrecoVariacao(grupo, indexPai, indexVar, novoPreco) {
    setData((pv) => {
      const lista = [...pv[grupo]]
      const pai = lista[indexPai]
      const variacoes = [...pai.variacoes]

      variacoes[indexVar] = { ...variacoes[indexVar], price: novoPreco }

      lista[indexPai] = {
        ...pai,
        variacoes,
      }
      return { ...pv, [grupo]: lista }
    })
  }

  /* --- VERIFICADORES DE CHECAGEM GERAL --- */
  const todosGeraisSelecionados =
    anuncios.length > 0 &&
    anuncios.every(
      (a) => a.selected && (a.variacoes || []).every((v) => v.selected),
    ) &&
    composicoes.every(
      (c) => c.selected && (c.variacoes || []).every((v) => v.selected),
    )

  const todosAnunciosSelecionados =
    anuncios.length > 0 &&
    anuncios.every(
      (a) => a.selected && (a.variacoes || []).every((v) => v.selected),
    )

  const todasComposicoesSelecionadas =
    composicoes.length > 0 &&
    composicoes.every(
      (c) => c.selected && (c.variacoes || []).every((v) => v.selected),
    )

  /* --- RENDERIZAÇÃO DE ITEM (PAI + FILHOS) --- */
  const renderItemCard = (item, indexPai, grupo) => {
    const temVariacoes = item.variacoes && item.variacoes.length > 0
    const isOpen = openMap[`${grupo}-${item.id}`]

    return (
      <div
        key={item.id}
        style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
      >
        {/* CARD PRINCIPAL */}
        <div
          style={{
            ...cardStyle,
            background: grupo === 'composicoes' ? '#f8fafc' : '#ffffff',
          }}
        >
          <input
            type="checkbox"
            checked={!!item.selected}
            onChange={(e) => selecionarPai(grupo, indexPai, e.target.checked)}
          />

          {temVariacoes && (
            <button
              type="button"
              onClick={() => toggleCollapse(`${grupo}-${item.id}`)}
              style={collapseButtonStyle}
            >
              {isOpen ? '▲' : '▼'}
            </button>
          )}

          {item.thumbnail ? (
            <img
              src={item.thumbnail}
              alt=""
              style={imageStyle}
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
          ) : (
            <div style={imagePlaceholderStyle}>Sem foto</div>
          )}

          <div style={{ flex: 1, minWidth: 0 }}>
            {item.permalink ? (
              <a
                href={item.permalink}
                target="_blank"
                rel="noreferrer"
                style={titleLinkStyle}
                title={item.title}
              >
                {item.title}
              </a>
            ) : (
              <div
                style={titleStyle}
                title={item.title}
              >
                {item.title}
              </div>
            )}
            <div style={metaStyle}>
              SKU: <strong>{item.seller_sku || 'N/A'}</strong> | MLB:{' '}
              {item.codigomk}
              {temVariacoes && (
                <span
                  style={{
                    color: '#2563eb',
                    marginLeft: '6px',
                    fontWeight: 'bold',
                  }}
                >
                  ({item.variacoes.length} variações)
                </span>
              )}
            </div>
          </div>

          <div style={rightContentStyle}>
            <div
              style={{
                display: 'flex',
              }}
            >
              <CustomButton
                title="Resetar"
                onClick={() =>
                  alterarPrecoPai(grupo, indexPai, adaptValue(item.old_price))
                }
              />

              <CustomPriceInput
                value={item.price}
                onChange={(e) =>
                  alterarPrecoPai(grupo, indexPai, adaptValue(e.target.value))
                }
              />
            </div>

            {item.status && (
              <span
                style={{
                  ...badgeStyle,
                  background: item.status === 'paused' ? '#fef3c7' : '#dcfce7',
                  color: item.status === 'paused' ? '#b45309' : '#15803d',
                }}
              >
                {item.status === 'paused' ? 'Pausado' : 'Ativo'}
              </span>
            )}
          </div>
        </div>

        {/* LISTA DE VARIAÇÕES (COLLAPSE) */}
        {temVariacoes && isOpen && (
          <div style={variationsContainerStyle}>
            {item.variacoes.map((variacao, indexVar) => (
              <div
                key={variacao.idvariacao || indexVar}
                style={variationCardStyle}
              >
                <input
                  type="checkbox"
                  checked={!!variacao.selected}
                  onChange={(e) =>
                    selecionarVariacao(
                      grupo,
                      indexPai,
                      indexVar,
                      e.target.checked,
                    )
                  }
                />

                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={titleStyle}
                    title={variacao.descricao}
                  >
                    {variacao.descricao}
                  </div>
                  <div style={metaStyle}>
                    SKU Var: <strong>{variacao.skuvariacao || 'N/A'}</strong>
                    {variacao.gtin && ` | EAN: ${variacao.gtin}`}
                  </div>
                </div>

                <div style={rightContentStyle}>
                  <div
                    style={{
                      display: 'flex',
                    }}
                  >
                    <CustomButton
                      title="Resetar"
                      onClick={() =>
                        alterarPrecoVariacao(
                          grupo,
                          indexPai,
                          indexVar,
                          adaptValue(variacao.old_price),
                        )
                      }
                    />

                    <CustomPriceInput
                      value={variacao.price}
                      onChange={(e) =>
                        alterarPrecoVariacao(
                          grupo,
                          indexPai,
                          indexVar,
                          adaptValue(e.target.value),
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }

  return (
    <div
      style={{
        width: '100%',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        color: '#1e293b',
      }}
    >
      {/* SELEÇÃO GLOBAL */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 5,
          marginTop: '10px',
        }}
      >
        <input
          id="select-all"
          type="checkbox"
          checked={todosGeraisSelecionados}
          onChange={(e) => selecionarTodos(e.target.checked)}
        />
        <label
          htmlFor="select-all"
          style={{
            fontSize: 14,
            fontWeight: 'bold',
            cursor: 'pointer',
            margin: 0,
          }}
        >
          Selecionar Todos
        </label>
      </div>

      {/* SEÇÃO: ANÚNCIOS DIRETOS */}
      <div style={{ marginTop: '15px' }}>
        <div style={sectionTitleStyle}>
          Anúncios Diretos ({anuncios.length})
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            margin: '8px 0',
          }}
        >
          <input
            id="select-all-anuncios"
            type="checkbox"
            checked={todosAnunciosSelecionados}
            onChange={(e) =>
              selecionarTodosPorGrupo('anuncios', e.target.checked)
            }
          />
          <label
            htmlFor="select-all-anuncios"
            style={{ fontSize: 13, cursor: 'pointer', margin: 0 }}
          >
            Selecionar Todos os Anúncios
          </label>
        </div>

        {anuncios.length === 0 ? (
          <div style={emptyStyle}>Nenhum anúncio direto encontrado.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {anuncios.map((item, index) =>
              renderItemCard(item, index, 'anuncios'),
            )}
          </div>
        )}
      </div>

      {/* SEÇÃO: COMPOSIÇÕES / KITS */}
      <div style={{ marginTop: '20px' }}>
        <div style={sectionTitleStyle}>Kits ({composicoes.length})</div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            margin: '8px 0',
          }}
        >
          <input
            id="select-all-composicoes"
            type="checkbox"
            checked={todasComposicoesSelecionadas}
            onChange={(e) =>
              selecionarTodosPorGrupo('composicoes', e.target.checked)
            }
          />
          <label
            htmlFor="select-all-composicoes"
            style={{ fontSize: 13, cursor: 'pointer', margin: 0 }}
          >
            Selecionar Todas as Composições
          </label>
        </div>

        {composicoes.length === 0 ? (
          <div style={emptyStyle}>Nenhuma composição encontrada.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {composicoes.map((item, index) =>
              renderItemCard(item, index, 'composicoes'),
            )}
          </div>
        )}
      </div>
    </div>
  )
}

/* --- ESTILOS CSS VANILLA --- */
const sectionTitleStyle = {
  fontSize: '13px',
  fontWeight: '700',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  color: '#64748b',
  borderBottom: '1px solid #e2e8f0',
  paddingBottom: '4px',
}

const cardStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '8px 12px',
  border: '1px solid #e2e8f0',
  borderRadius: '6px',
}

const variationsContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  paddingLeft: '28px',
  borderLeft: '2px solid #cbd5e1',
  marginLeft: '12px',
}

const variationCardStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '6px 10px',
  border: '1px dashed #cbd5e1',
  borderRadius: '4px',
  background: '#f8fafc',
}

const collapseButtonStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '10px',
  color: '#64748b',
  padding: '2px 4px',
}

const imageStyle = {
  width: '38px',
  height: '38px',
  objectFit: 'cover',
  borderRadius: '4px',
  border: '1px solid #cbd5e1',
  flexShrink: 0,
}

const imagePlaceholderStyle = {
  width: '38px',
  height: '38px',
  borderRadius: '4px',
  border: '1px border-dashed #cbd5e1',
  background: '#f1f5f9',
  color: '#94a3b8',
  fontSize: '9px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}

const titleStyle = {
  fontSize: '12px',
  fontWeight: '600',
  color: '#0f172a',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

const titleLinkStyle = {
  ...titleStyle,
  display: 'block',
  color: '#2563eb',
  textDecoration: 'none',
}

const metaStyle = {
  fontSize: '11px',
  color: '#64748b',
  marginTop: '2px',
}

const rightContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  justifyContent: 'center',
  flexShrink: 0,
}

const badgeStyle = {
  display: 'inline-block',
  padding: '2px 6px',
  borderRadius: '4px',
  fontSize: '10px',
  fontWeight: '700',
  marginTop: '4px',
}

const emptyStyle = {
  fontSize: '12px',
  color: '#94a3b8',
  fontStyle: 'italic',
  padding: '6px 0',
}
